import { Injectable } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

@Injectable({providedIn:'root'})
export class Navegacao {

    constructor(private router: Router) {
    }

    public run(route: Array<any>, relativeTo: ActivatedRoute = null, queryParams: Params = null, skipLocationChange: boolean = true) {
        this.router.navigate(route, 
            {
                relativeTo: relativeTo,
                queryParams: queryParams,
                skipLocationChange: skipLocationChange
            })
    }

    public data() {
        return this.router.events;
    }
}